import CustomerPointDetailModal from './customer-point-detail-modal.vue'
export default CustomerPointDetailModal
